import { Text } from 'ui-kit/typography'
import { CodeArchitecture } from 'routes/components/Features/CodeArchitecture'
import classes from './DifferenceAbstraction.module.scss'

export const DifferenceAbstraction = () => {
  return (
    <article className={classes.article}>
      <div className={classes.heading}>
        <Text size={'lg'} center balance className={classes.tagline}>
          Choose your level of abstraction
        </Text>
        <Text size={'lg'} center balance className={classes.subtitle}>
          You can keep writing the same front-end and backend code as before,
          but you don't have to. You can build simpler things that don't require
          coding skills in Ul or use YAML for configuring well-engineered
          standard components.
        </Text>
      </div>

      <CodeArchitecture bgIsVisible hasGradientBorder />
    </article>
  )
}
